var app;

app = window.App || (window.App = {});

app.InputEnabler = (function() {
  function InputEnabler(checkbox) {
    this.checkbox = checkbox;
  }

  InputEnabler.prototype.enable = function() {
    var selector;
    selector = $(this.checkbox).data('enable');
    return $("#" + selector).attr('disabled', !this.checkbox.checked && 'disabled').toggleClass('disabled', !this.checkbox.checked);
  };

  InputEnabler.prototype.disable = function() {
    var selector;
    selector = $(this.checkbox).data('disable');
    return $("#" + selector).attr('disabled', this.checkbox.checked && 'disabled').toggleClass('disabled', this.checkbox.checked);
  };

  return InputEnabler;

})();

$(document).on('change', 'input[data-disable]', function(e) {
  return new app.InputEnabler(this).disable();
});

$(document).on('change', 'input[data-enable]', function(e) {
  return new app.InputEnabler(this).enable();
});

$(document).on('turbo:load', function() {
  $('input[data-disable]').each(function(index, element) {
    return new app.InputEnabler(element).disable();
  });
  return $('input[data-enable]').each(function(index, element) {
    return new app.InputEnabler(element).enable();
  });
});
